import { Component, Input, Output, EventEmitter, ViewChild, OnInit, AfterViewInit, OnChanges, SimpleChange, ViewEncapsulation, OnDestroy } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FieldConfig, FieldTypeEnum } from '../dynamic-form/dynamicForm.interface';
import { CustomDropDownListOptions, DDidbResponse, DropdownListDataSourceEvent } from './customDropDownList.interface';

import * as _ from 'lodash';
import { debounceTime, filter, Observable, ReplaySubject, takeUntil } from 'rxjs';
import { DropdownServiceService } from 'src/app/services/dropdown-service.service';
import { GenericDD } from 'src/app/model/generic-data';
import { Subject } from 'rxjs';
import { trigger, transition, style, animate } from '@angular/animations';
import { MatSelect } from '@angular/material/select';
import { DecimalPipe } from '@angular/common';
import { ListRange } from '@angular/cdk/collections';
import { CdkVirtualScrollViewport, ScrollDispatcher } from '@angular/cdk/scrolling';
import { IdbService } from 'src/app/services/idb.service';
import { Session } from 'src/app/features/login/login';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { GlobalService } from 'src/app/services/global.service';
import { IdbDataResponse } from 'src/app/model/idb';
import { ToastService } from '../toast/toast.service';


@Component({
  selector: 'app-custom-drop-down-list',
  templateUrl: './custom-drop-down-list.component.html',
  styleUrls: ['./custom-drop-down-list.component.scss'],
  animations: [
    trigger('slideDownUp', [
      transition(':enter', [
        style({ overflow: 'hidden', height: '0', opacity: 0 }),
        animate('300ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ overflow: 'hidden', height: '*', opacity: 1 })),
      ]),
      transition(':leave', [
        style({ overflow: 'hidden', height: '*', opacity: 1 }),
        animate('330ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ overflow: 'hidden', height: '0', opacity: 0 })),
      ]),
    ]),
    trigger('opacity', [
      transition(':enter', [
        style({ height: 0, opacity: 0 }),
        animate('500ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ height: '*', opacity: 1 })),
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('50ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ height: 0, opacity: 0 })),
      ]),
    ]),
  ],
  encapsulation: ViewEncapsulation.None // il css nasce e muore qui
  ,
  standalone: false
})
export class CustomDropDownListComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {

  @ViewChild('dropdownList') dropDownListObj: MatSelect | undefined;

  @Input() options: CustomDropDownListOptions | undefined;
  @Input() field: FieldConfig | undefined;
  @Input() group!: FormGroup | undefined;
  @Input() api?: boolean;
  @Input() url?: string = '';
  @Input() idb?: boolean;
  @Input() idbTable?: string;
  @Input() idbParent?: Record<string, any>;
  @Input() placeholder?: string = '';
  @Input() fieldName: string | undefined;
  @Input() value: any;

  @Input() updateDataSource: EventEmitter<any> = new EventEmitter<any>();
  @Input() getDataSource: EventEmitter<string> = new EventEmitter<string>();

  @Output() change: EventEmitter<any> = new EventEmitter<any>();
  @Output() genericChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() sendDataSource: EventEmitter<DropdownListDataSourceEvent> = new EventEmitter<DropdownListDataSourceEvent>();
  @Output() dataSourceReady: EventEmitter<string> = new EventEmitter<string>();

  data: Observable<GenericDD[]> = new Observable<GenericDD[]>;

  filter$: Subject<string> = new Subject<string>;

  fetchingEnd$: Subject<void> = new Subject<void>;

  ogData: GenericDD[] = []; //the original shit we get from api
  dataSource: GenericDD[] = [];// the copy we make where we could be applying filters
  visibleData: GenericDD[] = [];// the shit you see
  ready: boolean = false;

  /** control for the MatSelect filter keyword multi-selection */
  public dataMultiFilterCtrl: FormControl<string | null> = new FormControl<string | null>('');

  /** list of banks filtered by search keyword */
  public filteredDataMulti: ReplaySubject<GenericDD[]> = new ReplaySubject<GenericDD[]>(1);

  showAdd: boolean = false;

  // @Output() onDropdownChanges: EventEmitter<any> = new EventEmitter<any>();

  parsedOptions: CustomDropDownListOptions | undefined;
  parsedData: Array<any> | undefined;
  private theEnd$: Subject<void> = new Subject<void>();

  parsedFieldName: string = '';
  currentSelectedCode: string = '';
  currentSelectedObj?: GenericDD;

  extraData: string = '';
  extraDataSubject: Subject<string> = new Subject<string>();

  extraDataList: Array<string> = [];
  isEmpty: boolean = false;

  offset: number = 0;
  max: number = 150;
  ogMax: number = 150;
  endOfPagination: boolean = false;

  focus$ = new Subject<string>();

  constructor(
    private dds: DropdownServiceService,
    private deciPipe: DecimalPipe,
    private idbService: IdbService,
    private localStorageService: LocalStorageService,
    private globalService: GlobalService,
    private toastService: ToastService,
  ) {



  }

  ngOnInit() {
    if (this.fieldName == undefined) {
      this.parsedFieldName = "custom-dropdown-compp";
    } else {
      this.parsedFieldName = this.fieldName;
    }

    this.dropdownOperations();

    this.dataMultiFilterCtrl.valueChanges
      .pipe(takeUntil(this.theEnd$))
      .subscribe(() => {
        this.filterDataMulti();
      });

    this.extraDataSubject.pipe(takeUntil(this.theEnd$), debounceTime(200)).subscribe({
      next: (data: string) => {
        if (data.endsWith('//')) {
          this.extraData = data.replace('//', '');
          this.addToList();
        } else {
          this.extraData = data;
        }
      }
    });

    this.updateDataSource.pipe(takeUntil(this.theEnd$)).subscribe((event: any) => {
      console.log("TIME FOR AND UPDATE")
      if (event == this.field?.name) {
        this.dropdownOperations(false);
      }
    })

    this.getDataSource.pipe(takeUntil(this.theEnd$)).subscribe((event: string) => {
      if (this.field && event == this.field.name) {
        this.sendDataSource.emit({ data: this.dataSource, field: this.field.name });
      }
    })

    this.fetchingEnd$.pipe(takeUntil(this.theEnd$)).subscribe(() => {
      this.ready = true;
      this.focus$.next('');
    })

    this.filter$.pipe(debounceTime(200)).subscribe(filterVal => {
      console.error(this.value)
      console.error(filterVal)

      if (filterVal.length > 0) {
        filterVal = filterVal.trim();

        this.dataSource = _.cloneDeep(this.ogData.filter(x => x.codice.toLowerCase().includes(filterVal.toLowerCase())));

      } else {
        this.dataSource = _.cloneDeep(this.ogData);

      }

      /* let currentVal = this.dataSource.find(x => x.id == this.field?.value || this.value);
      if (currentVal) {
        this.dataSource.splice(this.dataSource.findIndex(x => x.id == currentVal.id))
        this.dataSource.unshift(currentVal);
      } */

      console.warn(this.dataSource)
      console.warn(this.ogData)

      this.offset = 0;
      this.visibleData = [];

      /* if (this.value != null) {
        if (this.options?.multiple) {
      
        } else {

          if (!this.dataSource.find(x => x.id == this.value)) {
            this.changesDifferent(null)
            this.value = null;
          }
        }

      } */

      /*   let currentVal = this.dataSource.find(x => x.id == this.field?.value || this.value);
        if (currentVal) {
      
            this.dataSource.unshift(currentVal)
          
        } */

      if (this.dataSource.length <= this.max) {
        this.max = this.dataSource.length;
        this.visibleData.push(...this.dataSource);
        this.distinctVisibleData();
      } else {
        this.max = this.ogMax;
        const slicedArray = this.dataSource.slice(0, this.max);
        this.visibleData.push(...slicedArray);
        this.distinctVisibleData();
      }
      this.offset = this.offset + this.max;
      /*for (let i = this.offset; i < this.max; i++) {

        
        this.offset++;
      }*/
    })

    this.focus$.pipe(takeUntil(this.theEnd$)).subscribe({
      next: (data: string) => {
        setTimeout(() => {
          let inputFilter = document.getElementById('filterInput');
          if (inputFilter) {
            inputFilter.focus();
          } else {
            console.error(inputFilter)
          }
        }, 100);
      }
    })
  }


  protected filterDataMulti() {
    if (!this.ogData) {
      return;
    }
    // get the search keyword
    let search = this.dataMultiFilterCtrl.value;
    if (!search) {
      this.filteredDataMulti.next(this.dataSource.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredDataMulti.next(
      this.dataSource.filter(bank => bank.codice.toLowerCase().indexOf(search) > -1)
    );
  }

  getCurrentValueById(id: string | number): string {
    return this.findOptionByValue(id)?.codice ?? '';
  }

  private getMultipleSelectedValues(): Array<string | number> {
    if (this.group && this.field) {
      const groupValue = this.group.controls[this.field.name]?.value;
      if (Array.isArray(groupValue)) {
        return groupValue;
      }
    }

    if (Array.isArray(this.field?.value)) {
      return this.field.value;
    }

    if (Array.isArray(this.value)) {
      return this.value;
    }

    return [];
  }

  changes(event: any) {
    console.log('CHANGESSS')
    console.warn(event);
    const selectedOption = this.findOptionByValue(event);
    this.value = event;
    this.change.emit({
      id: event,
      codice: selectedOption?.codice ?? event,
      field: this.field?.name
    });
    if (this.options && this.options.multiple) {
      this.currentSelectedCode = this.findOptionByValue(event[0])?.codice || 'Seleziona un valore';
    } else {
      this.currentSelectedCode = selectedOption?.codice || event || 'Seleziona un valore';
    }
    this.currentSelectedObj = selectedOption;

  }

  ngOnChanges(changes: { options: SimpleChange, field: SimpleChange }): void {
    if (!this.group) {
      if (changes.options) {
        console.error(this.field?.name + " CHANGESSS")
        this.options = this.field?.options;
        if (this.url != this.options?.url) {
          console.error("URL CHANGES")
          this.dropdownOperations();
        }
      }
      if (changes.field && changes.field.currentValue)
        this.parseData(changes.field.currentValue);
    }

    if (changes.options) {
      console.error(this.field?.name + " CHANGESSS")
      this.options = this.field?.options;
      if (this.url != this.options?.url) {
        console.error("URL CHANGES")
        this.dropdownOperations();
      }
    }
  }

  ngAfterViewInit(): void {



    //this.dropDownListObj!.value = this.group ?? (this.field?.value! as CustomDropDownListOptions)!.value  ? (this.field?.value! as CustomDropDownListOptions)?.value!: this.field?.value!;

    // imposto focus sull'oggetto se serve
    /*if(this.field != undefined && this.field.autoFocus != undefined && this.field.autoFocus != false) {
      var le = document.getElementById(this.field!.name)!.getElementsByTagName("input");
      for(let i = 0; i < le!.length; i++) {
        le[i].focus();
      }
    }*/
  }


  private parseOptions(options: CustomDropDownListOptions) {
    this.parsedOptions = _.cloneDeep(options);
  }

  private parseData(data: Array<any>) {
    this.parsedData = _.cloneDeep(data);
  }

  beforeTooltipOpen(e: any) {
    if (this.field != undefined || this.field != null) {
      if (this.field.tooltip == null || this.field.tooltip == undefined || this.field.tooltip == '') {
        e.cancel = true;
      }
    }
  }

  focus(event: any) {
    if (this.field) {
      console.log(this.options);
      console.log(this.field?.options)
      this.options = this.field?.options;
    }

    if (this.url != this.options?.url) {
      this.dropdownOperations(true);
    } else {
      this.visibleData = [];
      this.max = this.ogMax;
      this.offset = 0;
      this.dataSource = _.cloneDeep(this.ogData);

      if (this.dataSource.length <= this.max) {
        this.max = this.dataSource.length;
      }
      let currentVal = this.dataSource.find(x => x.id == this.field?.value || this.value);
      if (currentVal) {
        this.visibleData.unshift(currentVal)
        this.distinctVisibleData();
      }

      for (let i = this.offset; i < this.max; i++) {
        if (!this.visibleData.includes(this.dataSource[i])) {
          this.visibleData.push(this.dataSource[i])
          this.distinctVisibleData();
          this.offset++;
        }
      }

      this.ready = true;
      this.focus$.next('');
    }

    setTimeout(() => {
      let inputFilter = document.getElementById('filterInput');
      if (inputFilter) {
        inputFilter.focus();
      } else {
        console.error(inputFilter)
      }

    }, 110);

  }

  dropdownOperations(focus?: boolean) {
    this.ready = false;
    if (this.field) {
      this.options = _.cloneDeep(this.field?.options);
      this.api = this.options?.api;
      this.url = this.options?.url;

      this.idb = this.options?.idb;
      this.idbTable = this.options?.idbTable;
      this.idbParent = this.options?.idbParent;
    }

    if (this.idb == true && this.idbTable != undefined) {
      console.warn("\n \n checking idb for dropdown \n \n");
      this.idbService.getItemRow(this.idbTable, this.globalService.getIdbTableKey(this.idbTable,
        //this.session?.id ?? 
        '')).then((res: IdbDataResponse) => {
          console.warn(res);
          if (res != undefined) {
            if (res.item != undefined) {
              let dataRaw: Array<DDidbResponse> = res.item;
              let data: Array<DDidbResponse> = [];

              // DONT CHANGE THIS I DON'T EVEN KNOW WHY AND HOW IT WORKS 💀💀
              console.warn("\n \n \n IDB PARENT DATA \n \n \n");
              console.warn(this.idbParent);
              console.warn(JSON.stringify(this.idbParent));

              if (this.idbParent) {
                // loop over each [key, lookupValue] in your map
                /*for (const key in this.idbParent) {
                  const lookupValue = this.idbParent[key];
              
                  // compare with === instead of just checking truthiness
                  const matches = dataRaw.filter(item =>
                    item.parent?.[key] === lookupValue
                  );
              
                  data.push(...matches);
                }*/
                const filtered = dataRaw.filter(item =>
                  Object.entries(this.idbParent!).every(
                    ([key, val]) => item.parent?.[key] === val
                  )
                );

                // if you still want to push rather than reassign:
                data.length = 0;       // clear
                data.push(...filtered);
              } else {
                data = dataRaw;
              }

              this.max = this.ogMax;
              this.offset = 0;
              this.dataSource = [];
              this.visibleData = [];

              if (data.length == 0) {
                this.initDataFromApi();
                return;
                //this.isEmpty = true;
              } else {
                this.isEmpty = false;
              }
              this.dataSource = data;
              this.ogData = data;

              this.filteredDataMulti.next(this.ogData.slice());

              if (this.dataSource.length <= this.max) {
                this.max = this.dataSource.length;
              }
              if (this.options?.multiple) {
                console.log('multiple')
                const selectedValues = this.getMultipleSelectedValues();
                if (selectedValues.length > 0) {

                  if (this.group && this.field)
                    this.group.controls[this.field.name].setValue(selectedValues.filter((x: any) => this.dataSource.find(z => z.id == x)));
                  this.changes(selectedValues.filter((x: any) => this.dataSource.find(z => z.id == x)));
                }
              } else {

                let currentVal = this.dataSource.find(x => x.id == this.field?.value || this.value);
                if (currentVal) {
                  this.dataSource.unshift(currentVal)
                  this.distinctVisibleData();
                }
              }

              for (let i = this.offset; i < this.max; i++) {
                if (!this.visibleData.includes(this.dataSource[i])) {
                  this.visibleData.push(this.dataSource[i])
                  this.distinctVisibleData();
                  this.offset++;
                }
              }

              if (this.options?.multiple) {
                const selectedValues = this.getMultipleSelectedValues();
                const firstSelectedValue = selectedValues[0];
                this.currentSelectedCode =
                  this.dataSource.find((x) => x.id == firstSelectedValue)?.codice ||
                  'Seleziona un valore';
                this.currentSelectedObj = this.dataSource.find(
                  (x) => x.id == firstSelectedValue,
                );
              } else {
                this.currentSelectedCode = this.dataSource.find(x => x.id == this.field?.value || this.value)?.codice || 'Seleziona un valore';
                this.currentSelectedObj = this.dataSource.find(x => x.id == this.field?.value || this.value);
              }

              setTimeout(() => {
                this.ready = true;
                this.focus$.next('');
                this.dataSourceReady.emit(this.field?.name);
              }, 100);

            } else {
              this.initDataFromApi();
            }
          } else {
            this.initDataFromApi();
          }
        });
    } else {
      if (this.api) {
        this.initDataFromApi();

      } else {

        this.max = this.ogMax;
        this.offset = 0;
        this.dataSource = [];
        this.visibleData = [];
        if (this.field && this.field.data) {

          if (this.field.data.length == 0) {
            this.isEmpty = true;
          } else {
            this.isEmpty = false;
          }

          this.dataSource = this.field.data;
          this.ogData = this.field.data;

          this.filteredDataMulti.next(this.ogData.slice());

          if (this.dataSource.length <= this.max) {
            this.max = this.dataSource.length;
          }
          let currentVal = this.dataSource.find(x => x.id == this.field?.value || this.value);
          if (currentVal) {
            this.visibleData.unshift(currentVal)
            this.distinctVisibleData();
          }

          for (let i = this.offset; i < this.max; i++) {
            if (!this.visibleData.includes(this.dataSource[i])) {
              this.visibleData.push(this.dataSource[i])
              this.distinctVisibleData();
              this.offset++;
            }
          }

          this.currentSelectedCode = this.dataSource.find(x => x.id == this.field?.value || this.value)?.codice || 'Seleziona un valore';
          this.currentSelectedObj = this.dataSource.find(x => x.id == this.field?.value || this.value);

          setTimeout(() => {
            this.ready = true;
            this.focus$.next('');
          }, 100);
        }
      }
    }


  }

  initDataFromApi() {
    if (!this.api) {
      return;
    }
    this.dds.GenericDD(`${this.url}`)
      .pipe(
        takeUntil(this.theEnd$)
      ).subscribe({
        next: (data: GenericDD[]) => {
          const normalizedData = this.normalizeDropdownData(data);

          this.max = this.ogMax;
          this.offset = 0;
          this.dataSource = [];
          this.visibleData = [];

          if (normalizedData.length == 0) {
            this.isEmpty = true;
          } else {
            this.isEmpty = false;
          }
          this.dataSource = normalizedData;
          this.ogData = normalizedData;

          this.filteredDataMulti.next(this.ogData.slice());

          if (this.dataSource.length <= this.max) {
            this.max = this.dataSource.length;
          }
          let currentVal = this.dataSource.find(x => x.id == this.field?.value || this.value);
          if (currentVal) {
            this.visibleData.unshift(currentVal)
            this.distinctVisibleData();
          }

          for (let i = this.offset; i < this.max; i++) {
            if (!this.visibleData.includes(this.dataSource[i])) {
              this.visibleData.push(this.dataSource[i])
              this.distinctVisibleData();
              this.offset++;
            }
          }

          this.currentSelectedCode = this.dataSource.find(x => x.id == this.field?.value || this.value)?.codice || 'Seleziona un valore';
          this.currentSelectedObj = this.dataSource.find(x => x.id == this.field?.value || this.value);

          setTimeout(() => {
            this.ready = true;
            this.focus$.next('');
          }, 100);

        },
        error: (data: GenericDD[]) => {
          /*this.dataSource = [];
          this.visibleData = [];
          this.ready = true;
          this.focus$.next('');*/
          this.dataSource = [];
          this.visibleData = [];
          this.ready = true;
          this.focus$.next('');
          this.dataSourceReady.emit(this.field?.name);
        }
      });
  }

  click(event: any) {

  }

  findCurrentElement(): GenericDD | undefined {
    return this.ogData.find(x => x.id == this.field?.value || this.value);
  }

  onScroll(event: any) {
    if (this.endOfPagination == false) {
      let target = event.target as HTMLElement;
      let scrollPos = (Number(this.deciPipe.transform((target.scrollTop) / (target.scrollHeight - target.clientHeight) * 100, '1.0-0')));

      console.warn(scrollPos)
      if (scrollPos >= 98) {


        //  console.log("UUUUUAAA")

        if (this.dataSource.length <= this.max) {
          this.max = this.dataSource.length;
          this.endOfPagination = true;
          console.log("UUUUUAAA")
        }

        /*console.warn("offset ");
        console.warn(this.offset);
        if(this.dataSource.length == this.offset) {
          console.warn("data source it = offset");
          this.endOfPagination = true;
        }else{
          console.warn("data source != offset");
          const slicedArray = _.cloneDeep(this.dataSource.slice(this.offset - 1 , this.max - 1));
          this.visibleData.push(...slicedArray);
          this.offset = this.offset + this.max;

          console.warn(slicedArray);
          console.warn(this.offset);
          console.warn(this.max);
          console.warn(this.visibleData);
          console.warn(this.dataSource);
        }*/



        for (let i = 0; i < this.max; i++) {

          if (this.dataSource.length == this.offset) {
            this.endOfPagination = true;
            //console.log("UUUUUAAA")
          } else {
            this.visibleData.push(this.dataSource[this.offset + i])
            this.distinctVisibleData();
            this.offset++;
            //console.log("UUUUUAAA")
          }


        }
      }
    }


  }

  ngOnDestroy(): void {
    this.theEnd$.next();
    this.theEnd$.complete();
  }

  addDataExtra(event: any) {
    console.warn(event);
    if (event.key == 'Enter') {
      this.extraDataSubject.next(event.target.value + "//");
    } else {
      this.extraDataSubject.next(event.target.value);
    }
  }

  openCloseExtraClick(event: any) {
    console.warn("\n \n \n key press \n \n \n");
    console.warn(event);
    if (event.key == 'Enter') {
      this.openCloseExtra();
    }
  }

  openCloseExtra() {
    this.showAdd = !this.showAdd;

    setTimeout(() => {
      let el = document.getElementById('add-value-to-dd-' + this.field?.name);
      if (el != undefined) {
        el.focus();
      }
    }, 100);

    this.group!.controls[this.field!.name].reset();
  }
  addToListKeyPress(event: any) {
    if (event.key == 'Enter') {
      this.addToList();
    }
  }

  filterChange(event: any) {
    this.filter$.next(event.target.value);

    if (this.field?.type == FieldTypeEnum.autoComplete) {
      this.changes(event.target.value)
    }
  }

  addToList() {

    let data = this.extraData.trim();

    if (data == '') {
      return;
    }

    /*this.dataSource.push(...[{
      codice: data,
      id: data,
    }]);*/

    if (this.extraDataList.find(x => x == data) == undefined) {
      this.visibleData.push(
        {
          codice: data,
          id: data,
        }
      );
      this.dataSource.push(
        {
          codice: data,
          id: data,
        }
      );
      this.ogData.push(
        {
          codice: data,
          id: data,
        }
      );
      this.value = data;
      this.field!.value = data;
      this.extraDataList.push(...[this.extraData.trim()]);
      //this.ogData.push(...[this.extraData.trim()])
    }

    /*let x = this.data as Array<Object>;
    
    x.push(...[{
      codice: this.extraData.trim(),
      id: this.extraData.trim(),
    }]);*/

    this.extraData = '';
    this.showAdd = false;
    if (this.dropDownListObj != undefined) {
      console.warn("THE SHIT IS NOT UNDEFINED");
      /*     setTimeout(() => {
            this.dropDownListObj!.value = data;
            //this.dropDownListObj?.writeValue(this.extraData.trim());
          }, 100); */
      this.group!.controls[this.field!.name].setValue(data);
      //this.field!.value = this.extraData.trim();      
    }
    setTimeout(() => {
      let el = document.getElementById('add-value-to-dd-starter-btn-' + this.field?.name);
      if (el != undefined) {
        el.focus();
      }
    }, 10);
  }

  changesDifferent(e: any) {
    let ev = {
      id: e,
      codice: this.dataSource.find(x => x.id == e)?.codice,
      field: this.fieldName
    }
    this.genericChange.emit(ev);
  }


  getSVG(svg: any) {
    return btoa(svg)
  }

  modifySvgSize(svgString: string, newSize: number, newHeight: number): string {
    // Modify the style attribute with the new size and height        
    let modifiedSvgString = svgString;
    if (svgString.search(/height=".*?"/) > -1) {
      modifiedSvgString = modifiedSvgString.replace(/height=".*?"/, `height="${newHeight}"`);
    } else {
      modifiedSvgString = modifiedSvgString.replace("<svg", `<svg height="${newHeight}"`);
    }

    if (svgString.search(/width=".*?"/) > -1) {
      modifiedSvgString = modifiedSvgString.replace(/width=".*?"/, `width="${newSize}"`);
    } else {
      modifiedSvgString = modifiedSvgString.replace("<svg", `<svg width="${newSize}"`);
    }

    modifiedSvgString = modifiedSvgString.replace(/id=".*?"/, '');
    //modifiedSvgString = modifiedSvgString.replace(/style=".*?"/, `style="width:${newSize}px;height:${newHeight}px"`);    
    //if(svgString.search(/style=".*?"/) > -1) {
    modifiedSvgString = modifiedSvgString.replace(/style=".*?"/, ``);
    //}

    return modifiedSvgString;
  }

  open(event: any) {
    /* if (this.options?.showColor) {
      setTimeout(() => {
        let x = document.getElementById("colorPicker_popup");
        console.warn(x);
        let xs = document.querySelector('.e-content.e-dropdownbase');
        xs?.setAttribute("style", "max-height: 500px");

      }, 100);      
    } */
    //console.warn("\n \n \n \n \n \n opend select \n \n \n \n \n \n \n")
    if (!this.dropDownListObj?.disabled) {

      //this.ready = false;
    }


  }

  distinctVisibleData() {
    this.dataSource = [...new Set(this.dataSource)];
  }

  getOptionValue(option: GenericDD): string | number | null {
    if (this.field?.type === FieldTypeEnum.autoComplete && this.field.typeAheadOptionField === 'codice') {
      return option.codice;
    }

    return option.id;
  }

  private findOptionByValue(value: any): GenericDD | undefined {
    return this.dataSource.find(x => x.id == value || x.codice == value);
  }

  private normalizeDropdownData(data: any[]): GenericDD[] {
    return (data || []).map((item) => ({
      ...item,
      codice: item?.codice ?? item?.name ?? '',
    }));
  }

  canDeleteOption(): boolean {
    const deleteUrls = ['-missions/categories', '-missions/locations', '-pois/types'];
    return !!this.api && !!this.url && deleteUrls.includes(this.url);
  }

  deleteOption(option: GenericDD, event: Event): void {
    event.stopPropagation();
    event.preventDefault();

    if (!this.url || option.id === null || option.id === undefined) {
      return;
    }

    const confirmed = confirm(`Eliminare "${option.codice}"?`);
    if (!confirmed) {
      return;
    }

    this.dds.GenericDDDelete(this.url, option.id)
      .pipe(takeUntil(this.theEnd$))
      .subscribe({
        next: () => {
          this.toastService.success('Elemento eliminato');

          this.dataSource = this.dataSource.filter((x) => x.id !== option.id);
          this.ogData = this.ogData.filter((x) => x.id !== option.id);
          this.visibleData = this.visibleData.filter((x) => x.id !== option.id);
          this.filteredDataMulti.next(this.dataSource.slice());

          if (this.value === option.id || this.value === option.codice) {
            this.value = null;
            this.currentSelectedCode = 'Seleziona un valore';
            this.currentSelectedObj = undefined;
            if (this.group && this.field) {
              this.group.controls[this.field.name].setValue(null);
            }
          }
        },
        error: () => {
          this.toastService.error('Errore durante l\'eliminazione');
        }
      });
  }


  selectAll() {
    this.dropDownListObj?.close();
    setTimeout(() => {
      if (!this.group || !this.field) return;
      let value = this.dataSource.map(x => x.id);
      this.group.controls[this.field.name].setValue(value);
      this.changes(value)
    }, 100);
  }

  deselectAll() {
    this.dropDownListObj?.close();
    setTimeout(() => {
      if (!this.group || !this.field) return;
      this.group.controls[this.field.name].setValue([]);
      this.changes([])
    }, 100);
  }

}
